import { PAYMENTS_URL } from '../config/env';

let initializedPixelId = '';

export function initializeMetaPixel(pixelId) {
  const id = String(pixelId || '').trim();
  if (!/^\d{10,20}$/.test(id) || initializedPixelId === id || typeof window === 'undefined') return false;
  initializedPixelId = id;
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = true; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', id);
  return true;
}

function recordAggregateEvent(eventName, params) {
  if (typeof window === 'undefined') return;
  // Purchases are counted server-side only after Mercado Pago reports approved.
  if (eventName === 'Purchase') return;
  const value = ['Purchase', 'InitiateCheckout'].includes(eventName) ? Number(params?.value) || 0 : 0;
  try {
    fetch(`${PAYMENTS_URL}?action=track_event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: eventName, value }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* métricas agregadas son best-effort */ }
}

export function trackPixelEvent(eventName, params = {}, options) {
  recordAggregateEvent(eventName, params);
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return false;
  try {
    window.fbq('track', eventName, params, options);
    return true;
  } catch (err) {
    console.error('[metaPixel] error trackeando', eventName, err);
    return false;
  }
}

export function trackPixelEventOnce(eventName, dedupeId, params) {
  if (typeof window === 'undefined' || !dedupeId) return false;
  const storageKey = `ch_pixel_${eventName}_${dedupeId}`;
  try { if (sessionStorage.getItem(storageKey)) return false; } catch { /* continúa sin dedupe */ }
  try { sessionStorage.setItem(storageKey, '1'); } catch { /* best effort */ }
  return trackPixelEvent(eventName, params, { eventID: String(dedupeId) });
}
